'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;
/*
import { LinkContainer } from 'react-router-bootstrap';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
*/

// import * as companyActions from 'redux/modules/company';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var _company = require('redux/modules/company');

var _templateData = require('redux/modules/templateData');

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _semanticUiReact = require('semantic-ui-react');

var _professionalDetails = require('redux/modules/professionalDetails');

var professionalDetails = _interopRequireWildcard(_professionalDetails);

var _miscellaneousInfo = require('redux/modules/miscellaneousInfo');

var miscellaneousInfo = _interopRequireWildcard(_miscellaneousInfo);

var _saveUserData = require('redux/modules/saveUserData');

var _reactStripeElements = require('react-stripe-elements');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Joyride from 'react-joyride';


var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    var api_key = (0, _company.getAPI)(getState());
    var div_content_id = (0, _company.getDivContentId)(getState());
    /*if (!isInfoLoaded(getState())) {
      promises.push(dispatch(loadInfo()));
    }
    if (!isAuthLoaded(getState())) {
      promises.push(dispatch(loadAuth()));
    }*/
    if ((0, _auth.isLoaded)(getState())) {
      if (!(0, _company.isContentLoaded)(getState())) {
        promises.push(dispatch((0, _company.loadAvailableContentTemplateData)(api_key, div_content_id)));
      }

      if (!(0, _company.isDesignLoaded)(getState())) {
        promises.push(dispatch((0, _company.loadAvailableDesignTemplateData)(api_key, div_content_id)));
      }

      promises.push(dispatch((0, _saveUserData.load)(div_content_id)));
      if (!(0, _company.isAdditionalCompanyDataLoaded)(getState())) {
        promises.push(dispatch((0, _company.loadAdditionalCompanyData)(api_key)));
      }

      //Check for subscription and update data
      if ((0, _auth.isSubscriptionNeeded)(getState())) {
        promises.push(dispatch((0, _auth.subscription)()));
      }
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    personal_info: state.personalDetails,
    professional_info: state.professionalDetails,
    miscellaneous_info: state.miscellaneousInfo,
    template_data: state.templateData,
    subscribed: state.auth.subscribed,
    token: state.company.token,
    company_name: state.company.name,
    show_resume_name_modal: state.templateData.show_resume_name_modal,
    show_zip_recruiter_modal: state.company.show_zip_recruiter_modal,
    show_payment_modal: state.company.show_payment_modal,
    user_data: state.saveUserData,
    user_id: state.auth.user_id,
    ReactGA: state.company.ReactGA,
    base_url: state.company.base_url,
    div_content_id: state.company.div_content_id,
    type_of_document: state.company.type_of_document,
    company: state.company
  };
}, {
  logout: _auth.logout,
  pushState: _reactRouterRedux.push,
  cleanTemplateData: _templateData.clean,
  cleanProfessionalDetails: professionalDetails.clean,
  cleanMiscellaneousInfo: miscellaneousInfo.clean,
  saveUserData: _saveUserData.save,
  showResumeNameModal: _templateData.showResumeNameModal,
  showZipRecruiterModal: _company.showZipRecruiterModal,
  setResumeName: _templateData.setResumeName,
  showPaymentModal: _company.showPaymentModal
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      side_nav_visible: false,
      modalOpen: false,
      activeItem: 'HIRATION'
      // joyrideOverlay: true,
      // joyrideType: 'continuous',
      // isReady: false,
      // isRunning: false,
      // stepIndex: 0,
      // autoStart:true,
      // steps: [
      //     {
      //       title: `Welcome to Hiration's Resume Builder`,
      //       textAlign: 'center',
      //       selector: '.segment',
      //       position: 'top'
      //     },
      //     {
      //       title: 'Our Mission',
      //       text: 'Can be advanced by clicking an element through the overlay hole.',
      //       selector: 'button.labeled',
      //       position: 'bottom',
      //       allowClicksThruHole: true,
      //       style: {
      //         button: {
      //           display: 'none',
      //         }
      //       }
      //     },
      //     {
      //       title: 'About Us',
      //       text: 'We are the people',
      //       selector: '.PR',
      //       position: 'left',
      //       allowClicksThruHole: true,
      //       style: {
      //         beacon: {
      //           inner: '#27e200',
      //           offsetX: 20,
      //           outer: '#27e200'
      //         },
      //         arrow: {
      //           display: 'none'
      //         }
      //       }
      //     },
      //     {
      //       text: 'Text only steps — Because sometimes you don\'t really need a proper heading',
      //       selector: '.demo__footer a',
      //       position: 'top',
      //       isFixed: true,
      //       style: {
      //         beacon: '#000'
      //       }
      //     }
      //   ],
      // selector: '',
    }, _this.toggleVisibility = function (dimmer) {
      return function () {
        return _this.setState({ dimmer: dimmer, side_nav_visible: true });
      };
    }, _this.handleOpen = function (e) {
      return _this.setState({
        modalOpen: true
      });
    }, _this.handleClose = function (e) {
      return _this.setState({
        modalOpen: false
      });
    }, _this.handleItemClick = function (e, _ref3) {
      var name = _ref3.name;

      _this.setState({ activeItem: name });
      if (name == 'HIRATION') {
        _this.props.ReactGA.event({
          category: 'Resume - Header',
          action: 'Clicked on - My Resume',
          label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
        });
        _this.props.pushState(_this.props.base_url + '/dashboard');
      }
      if (name == 'LOGOUT') {
        _this.props.logout();
      }
    }, _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  //Joyride Code Starts ......................................................

  // componentDidMount() {
  //     setTimeout(() => {
  //       this.setState({
  //         isReady: true,
  //         isRunning: true,
  //       });
  //     }, 1000);
  //   }
  //
  // addSteps(steps) {
  //     let newSteps = steps;
  //
  //     if (!Array.isArray(newSteps)) {
  //       newSteps = [newSteps];
  //     }
  //
  //     if (!newSteps.length) {
  //       return;
  //     }
  //
  //     // Force setState to be synchronous to keep step order.
  //     this.setState(currentState => {
  //       currentState.steps = currentState.steps.concat(newSteps);
  //       return currentState;
  //     });
  //   }
  //
  //   addTooltip(data) {
  //     this.joyride.addTooltip(data);
  //   }
  //
  //   next() {
  //     this.joyride.next();
  //   }
  //
  //   callback(data) {
  //     console.log('%ccallback', 'color: #47AAAC; font-weight: bold; font-size: 13px;'); //eslint-disable-line no-console
  //     console.log(data); //eslint-disable-line no-console
  //
  //     this.setState({
  //       selector: data.type === 'tooltip:before' ? data.step.selector : '',
  //     });
  //   }
  //
  //   onClickSwitch(e) {
  //     e.preventDefault();
  //     const el = e.currentTarget;
  //     const state = {};
  //
  //     if (el.dataset.key === 'joyrideType') {
  //       this.joyride.reset();
  //
  //       setTimeout(() => {
  //         this.setState({
  //           isRunning: true,
  //         });
  //       }, 300);
  //
  //       state.joyrideType = e.currentTarget.dataset.type;
  //     }
  //
  //     if (el.dataset.key === 'joyrideOverlay') {
  //       state.joyrideOverlay = el.dataset.type === 'active';
  //     }
  //
  //     this.setState(state);
  //   }


  //Joyride Code Ends .............................................


  (0, _createClass3.default)(App, [{
    key: 'checkUniqueName',


    // close = () => this.setState({ showTemplateNameModal: false })
    // open = () => this.setState({ showTemplateNameModal: true })

    value: function checkUniqueName(data, value) {
      var isUnique = true;
      data.map(function (template) {
        if (template.name_of_template == value) {
          isUnique = false;
        };
      });
      if (isUnique && value) {
        // this.props.cleanInfo();
        // this.props.cleanTemplateData();
        this.props.setResumeName(value);
        // this.props.pushState('/app/choose-design');
        // if(this.props.company_data.name == 'Edureka') this.props.updateUserSubscription();
        // this.setState({showTemplateNameModal: false});
        this.props.showResumeNameModal(false);
      } else {
        alert('Please enter a unique ' + this.props.type_of_document + ' name.');
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      if (this.props.professional_info.length || this.props.miscellaneous_info.length) {
        var object = {};
        object['personal'] = this.props.personal_info;
        object['professional'] = this.props.professional_info;
        object['miscellaneous'] = this.props.miscellaneous_info;
        object['design_template_id'] = this.props.template_data.design_template_id;
        object['content_template_id'] = this.props.template_data.content_template_id;
        this.props.saveUserData(object);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if (nextProps.show_zip_recruiter_modal && !this.props.show_zip_recruiter_modal) {
        zipsearch.init({ "alerts_api_key": "jvw9m3z3djqp76s4iwbp2pxak7hvs3jg", "container": "zipsearch_container" });
      }

      if (!this.props.user && nextProps.user) {
        // login
        this.props.pushState(this.props.base_url + '/dashboard');
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState(this.props.base_url + '');
      }
      if (!this.props.user_id && nextProps.user_id) {
        ReactGA.set({ userId: nextProps.user_id });
      }
    }
  }, {
    key: 'openAccount',
    value: function openAccount() {
      window.location.href = '/myaccount';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var user = this.props.user;
      var showTemplateNameModal = this.state.showTemplateNameModal;

      var styles = require('./App.scss');
      var side_nav_visible = this.state.side_nav_visible;
      var activeItem = this.state.activeItem;

      var logoImage = require('./hiration_without_line.png');
      var _state = this.state,
          isReady = _state.isReady,
          isRunning = _state.isRunning,
          joyrideOverlay = _state.joyrideOverlay,
          joyrideType = _state.joyrideType,
          selector = _state.selector,
          stepIndex = _state.stepIndex,
          steps = _state.steps,
          autoStart = _state.autoStart;
      // console.log(this.props.company.brand_logo);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { id: 'resumeBuilderNav', inverted: true, style: { marginBottom: '0px' } },
          _react2.default.createElement(
            _semanticUiReact.Menu,
            { style: { backgroundColor: this.props.company.brand_color, zIndex: 1000 }, fixed: 'top', inverted: true, pointing: true, secondary: true },
            _react2.default.createElement(_semanticUiReact.Menu.Item, null),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { style: { padding: "5px" }, header: true, onClick: function onClick() {
                  _this2.props.ReactGA.event({
                    category: 'Resume - Header',
                    action: 'Clicked on - Logo',
                    label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                  });window.open(_this2.props.company.redirect_url, '_blank');
                } },
              this.props.company.brand_logo && _react2.default.createElement(_semanticUiReact.Image, { style: { height: "24px" }, src: this.props.company.brand_logo }),
              !this.props.company.brand_logo && _react2.default.createElement(_semanticUiReact.Image, { style: { height: "24px" }, src: logoImage })
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { className: 'dashboard-label', name: 'HIRATION', header: true, active: activeItem === 'HIRATION', onClick: this.handleItemClick },
              'My ',
              this.props.type_of_document,
              's'
            ),
            (this.props.company.show_get_premium || this.props.company.show_get_premium_in_app) && this.props.user && _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              { position: 'right' },
              !this.props.subscribed && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: styles.upgradeHeader, active: activeItem === 'UPGRADE' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { color: 'green', style: { cursor: 'pointer' },
                    onClick: function onClick() {
                      if (_this2.props.company.show_get_premium) {
                        window.open('/payment/', '_blank');
                      } else {
                        _this2.props.pushState(_this2.props.base_url + '/pricing');
                      }
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'lightning' }),
                  'Get Premium'
                )
              ),
              this.props.company.show_free_review && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'a',
                  { style: { cursor: 'pointer' }, onClick: function onClick() {
                      window.open('/free-resume-review/', '_blank');
                    } },
                  'FREE Resume Review'
                )
              ),
              this.props.company.show_resume_rewrite && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'a',
                  { style: { cursor: 'pointer' }, onClick: function onClick() {
                      window.open('/resume-rewrite/', '_blank');
                    } },
                  'Resume Rewrite'
                )
              ),
              this.props.company.show_account_dropdown && _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { style: {}, item: true, text: 'Account' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    { onClick: this.openAccount.bind(this) },
                    'Profile'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    { name: 'LOGOUT', active: activeItem === 'LOGOUT', onClick: this.handleItemClick },
                    'Logout'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          _react2.default.createElement(
            'div',
            null,
            this.props.children
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            dimmer: this.state.dimmer,
            open: this.state.modalOpen,
            onClose: this.handleClose
          },
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            { image: true },
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(
                _semanticUiReact.Header,
                null,
                'Confirm Save?'
              ),
              _react2.default.createElement(_semanticUiReact.Input, { placeholder: 'Enter Template Name...' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { color: 'black', onClick: this.close },
              'Nope'
            ),
            _react2.default.createElement(_semanticUiReact.Button, { positive: true, icon: 'checkmark', labelPosition: 'right', content: 'Save', onClick: this.close })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            size: 'mini'
            // style={{margin: '0 auto', left: '20%', top: 350, width: 500}}
            , open: this.props.show_resume_name_modal,
            onClose: function onClose() {
              return _this2.props.showResumeNameModal(false);
            } },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            'Name this ',
            this.props.type_of_document,
            ':'
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(_semanticUiReact.Input, {
              onChange: function onChange(event, data) {
                _this2.setState({ inputValueResumeName: data.value });
              },
              style: { textAlign: 'center', display: 'block' },
              placeholder: 'Enter name here...' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                onClick: function onClick() {
                  _this2.props.showResumeNameModal(false);
                  if ('/dashboard' != _this2.props.location.pathname) {
                    _this2.props.pushState(_this2.props.base_url + '/dashboard');
                  }
                },
                negative: true },
              'Cancel'
            ),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              icon: 'checkmark',
              labelPosition: 'right',
              content: 'Confirm',
              onClick: function onClick() {
                return _this2.checkUniqueName(_this2.props.user_data.load_data, _this2.state.inputValueResumeName);
              }
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            size: 'fullscreen'
            // style={{margin: '0 auto', left: '20%', top: 350, width: 500}}
            , open: this.props.show_zip_recruiter_modal,
            onClose: function onClose() {
              return _this2.props.showZipRecruiterModal(false);
            } },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            'Search for Jobs:'
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement('div', { id: 'zipsearch_container' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                onClick: function onClick() {
                  _this2.props.showZipRecruiterModal(false);
                },
                negative: true },
              'Cancel'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            size: 'small',
            open: this.props.show_payment_modal,
            onClose: function onClose() {
              return _this2.props.showPaymentModal(false, false, false);
            } },
          _react2.default.createElement(
            _reactStripeElements.StripeProvider,
            { apiKey: 'pk_live_YhzMw4eezgN70ZFuB4djntnm' },
            _react2.default.createElement(
              _reactStripeElements.Elements,
              null,
              _react2.default.createElement(_components.CheckoutForm, null)
            )
          )
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.bool,
  logout: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1755
// module chunks = 0